import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HotelPriceCalendarComponent } from './calendar/calendar.component';
import { ShortSearchParamsFacade } from "./short-search-params.facade";
import { ShortSearchParamsDesktopComponent } from "./desktop/short-search-params-desktop.component";
import { ShortSearchParamsMobileComponent } from "./mobile/short-search-params-mobile.component";
import { ShortSearchParamsAnalyticsService } from "./services/short-search-params-analytics.service";

@Component({
  selector: "app-short-search-params",
  templateUrl: "./short-search-params.component.html",
  styleUrls: ["./short-search-params.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ShortSearchParamsDesktopComponent, ShortSearchParamsMobileComponent],
  providers: [
    ShortSearchParamsFacade,
    ShortSearchParamsAnalyticsService,
    HotelPriceCalendarComponent,
  ],
})
export class ShortSearchParamsComponent implements OnInit, AfterViewInit {
  readonly isMobile = environment.mobile;

  constructor(private facade: ShortSearchParamsFacade) {}

  ngOnInit() {
    this.facade.init();
  }

  ngAfterViewInit() {
    history.scrollRestoration = "manual";
    document.dispatchEvent(new CustomEvent("_show-onboarding", {
      detail: {
        onboardingId: "mobile_hotel_tours_calendar"
      },
    }));
  }
}
